import { RegistriaUserRequest } from '../../models/registria/registria-user-request.interface';
import { mockRegistriaRequestCustomerDetails } from './registria-request-customer-details.mock';
import { mockRegistriaRequestRegisteredItem } from './registria-request-registered-item.mock';

export const mockRegistriaUserRequest: RegistriaUserRequest = {
  user: mockRegistriaRequestCustomerDetails,
  registration: mockRegistriaRequestRegisteredItem,
};
